// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"552cb734","171":"bb69caf3"}[chunkId] + ".chunk.js";
};